/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTopicDestinationRouteRequest
 */
export interface CreateTopicDestinationRouteRequest {
    /**
     * The ID of the topic.
     * @type {string}
     * @memberof CreateTopicDestinationRouteRequest
     */
    topicId: string;
    /**
     * The ID of the destination.
     * @type {string}
     * @memberof CreateTopicDestinationRouteRequest
     */
    destinationId: string;
}

/**
 * Check if a given object implements the CreateTopicDestinationRouteRequest interface.
 */
export function instanceOfCreateTopicDestinationRouteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "topicId" in value;
    isInstance = isInstance && "destinationId" in value;

    return isInstance;
}

export function CreateTopicDestinationRouteRequestFromJSON(json: any): CreateTopicDestinationRouteRequest {
    return CreateTopicDestinationRouteRequestFromJSONTyped(json, false);
}

export function CreateTopicDestinationRouteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTopicDestinationRouteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'topicId': json['topicId'],
        'destinationId': json['destinationId'],
    };
}

export function CreateTopicDestinationRouteRequestToJSON(value?: CreateTopicDestinationRouteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'topicId': value.topicId,
        'destinationId': value.destinationId,
    };
}

